
export { GGUSection } from "/codebuild/output/src2340768698/src/packages/shared-components/src/campaign/GGUSection.tsx"